<template>
  <v-row>
    <v-dialog ref="dialog" v-model="showDialog" scrollable persistent width="80%" style="z-index: 1001;">
      <v-card>
        <v-card-title>
					{{ !data || !data.id ? $t('wkt.admin.forms.edit-dialog.title-new') : $t('wkt.admin.forms.edit-dialog.title-edit') }}
        </v-card-title>
        <!--<v-card-title style="padding: 10px 0 0 10px; height: 20px;">
          <v-col cols="12">
						<span style="font-size: 20px;">
							{{ !data || !data.id ? $t('wkt.admin.forms.edit-dialog.title-new') : $t('wkt.admin.forms.edit-dialog.title-edit') }}
						</span>
          </v-col>
        </v-card-title>-->
				
        <v-card-text>
          <v-container style="max-width: 100%;">
						<v-form ref="form">
							<v-row>
								<v-col cols="6">
									<v-text-field
										v-model="data.name"
										:rules="[validationRules.required]"
										:label="$t('wkt.admin.forms.edit-dialog.name')"
									/>
								</v-col>

								<v-col cols="4">                
									<v-text-field
										v-model="data.externalId"
										:label="$t('wkt.admin.forms.edit-dialog.reference')"
										autocomplete="none"
										max="200"
									/>
								</v-col>

								<v-col cols="2">                
									<v-switch
										:label="$t('wkt.admin.forms.edit-dialog.enabled')"
										v-model="data.enabled">
									</v-switch>
								</v-col>
							</v-row>

							<v-row v-if="hasSubmissions" style="margin-top: 0; margin-bottom: 10px;">
								<v-col cols="12">  
									<v-alert type="warning" icon="warning" style="margin-bottom: 0;">
										{{ $t('wkt.admin.forms.edit-dialog.has-submissions') }}
									</v-alert>
								</v-col>
							</v-row>

							<v-row>
								<v-col cols="12">  
									<iframe ref="builder" style="min-width:100%; border:0;" :src="'form-builder.html?callbackId='+callbackId"/>
								</v-col>
							</v-row>
						</v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="showDeleteButton" color="#ff0000" @click="confirmDelete()">
						<v-icon left color="#ffffff">delete</v-icon>
						<span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
					</v-btn>
          <v-btn v-if="data && data.id" color="#124D91" text @click="createCopy()">{{ $t('wkt.admin.forms.edit-dialog.create-copy').toUpperCase() }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#124D91" text @click="ok()">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
          <v-btn text @click="showDialog=false">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
        </v-card-actions>
      </v-card>
			<LoadingDialog :loading="loading" />
    </v-dialog>

		<ConfirmDialog ref="dlgConfirm"
			v-bind:title="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.title')"
			v-bind:message="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.text')"
			v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
			v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
			v-on:confirmed="deleteItem()"
		/>
  </v-row>	
</template>

<script>
import BaseModule from '../common/BaseModule.js'
import ConfirmDialog from '../common/ConfirmDialog'
import LoadingDialog from '../common/LoadingDialog'
import api from '../../api/worktime'
import gwt from '../../api/gwt'

  export default {
    name: 'ReportTypeDialog',
    mixins: [BaseModule],
		components: {
			ConfirmDialog, LoadingDialog
		},
    data () {
      return {
				loading: false,
        showDialog: false,
        callbackId: 'form-builder-'+(new Date().getTime()),
        msgCb: null,
				showDeleteButton: false,
				hasSubmissions: false,
				myCompany: null,
      }
    },
    methods: {
			buildEmptyData() {
				var data = {
					id: null,
					name: null,
          externalId: null,
					definition: null,
					enabled: true,
				};

				return data;
			},
      open: function(companies, data, msgCb) {
		this.myCompany = gwt.getSessionInformation().company;
			
		//console.log("mi compañia--------->" +this.myCompany);
				if (this.$refs.form) {
					this.$refs.form.resetValidation();
				}
				
				
				this.clear(); 

        this.data = data;
  
				if (!this.data) {  
					this.data = this.buildEmptyData();
				}

        this.msgCb = msgCb;
				this.showDeleteButton = data != null;

				if (!data) {				
						this.hasSubmissions = false;	
						this.showDialog = true;
						this.fixDialog();
						return;
				}

				api.hasFormSubmissions(data.id,
					res => {
						this.hasSubmissions = res;
						this.showDialog = true;
						this.fixDialog();
					},
					(error) => {
						//this.errorMessage = error;
						this.$log.error(error);
						if (this.msgCb) {
              this.msgCb(error.message, false);
						}
					}
				);
				

				/*this.clear(); 

        this.data = data;
  
				if (!this.data) {  
					this.data = this.buildEmptyData();
				}

        this.msgCb = msgCb;
				this.showDeleteButton = data != null;
        this.showDialog = true;*/
			},
			fixDialog() {
        let me = this;
				this.$nextTick(() => {
					me.showDialog = false;
					me.$refs.builder.style.minHeight = (window.innerHeight * 0.9 - 230 -(this.hasSubmissions ? 116 : 36)) +'px';
					me.$refs.builder.contentWindow.postMessage(me.data.definition?me.data.definition : '{}');
					this.$nextTick(() => { //necesitamos hacer esto por problema en el cálculo de z-index de los overlays entre Material y Bootstrap
						me.showDialog = true;
					});								
				});
      },
		clear() {			
				this.data = this.buildEmptyData();
			},
			ok: function() {
				if (!this.$refs.form.validate()) {
					return;
				}
 
				this.data.updateDate = new Date().getTime();

				if (!this.data.creationDate) {
					this.data.creationDate = this.data.updateDate;
				}

				this.storeForm();
      },
      processMessage(msg) {
          if (!msg.data) return;

          if (!msg.data.target || msg.data.target!=this.callbackId) return;

          if (msg.data.type==='ready') {
              this.$refs.builder.contentWindow.postMessage(this.data.definition?this.data.definition:'{}');
              return;
          }


          if (msg.data.type==='schemaUpdate') {
              this.data.definition = JSON.stringify(msg.data.payload);
                return;
          }
          
        },
			confirmDelete() {
				this.$refs.dlgConfirm.confirm(this.data);
			},
			deleteItem() {	
				this.loading = true;	

				api.deleteForm(this.data.id,
					res => {
						this.loading = false;
						this.showDialog = false;
            if (this.msgCb) {
							this.msgCb(res.message, res.rsOK);
						}
					},
					(error) => {
						this.loading = false;
						this.$log.error(error);
						if (this.msgCb) {
              this.msgCb(error.message, false);
						}
					}
				);
			},
			createCopy() {
				if (!this.$refs.form.validate()) {
					return;
				}

				this.data.id = null;
				this.data.creationDate = new Date().getTime();
				this.data.updateDate = this.data.creationDate;
				this.data.name += " - " + this.$t('wkt.admin.forms.edit-dialog.copy').toUpperCase();

				this.storeForm();
			},
			storeForm() {
				this.loading = true;

				api.storeForm(this.data,
					res => {
						this.loading = false;
						this.showDialog = false;
            if (this.msgCb) {
							this.msgCb(res.message, res.rsOK);
						}
					},
					error => {
						this.loading = false;
						this.$log.error(error);
						if (this.msgCb) {
              this.msgCb(error.message, false);
						}
					});
			}
    },
    mounted: function ()  {
         if (window.addEventListener) {
                window.addEventListener("message", this.processMessage, false);
            }
            else {
                window.attachEvent("onmessage", this.processMessage);
            }
      
  },
  }
</script>